const ENABLED_WIDTHS = [
  320, 640, 960, 1280, 1600, 1920, 2240, 2560, 2880, 3200, 3520, 3840, 4160,
];

export function generateSrcSet(
  src: string,
  maxWidth?: number,
  widths = ENABLED_WIDTHS
): string {
  const limitedWidths = widths.filter((it) => it <= (maxWidth ?? Infinity));

  if (maxWidth && (limitedWidths[limitedWidths.length - 1] ?? 0) < maxWidth) {
    limitedWidths.push(maxWidth);
  }

  return limitedWidths
    .map((it) => `${src}${src?.includes("?") ? "&" : "?"}w=${it} ${it}w`)
    .join(", ");
}
